module.exports = __webpack_public_path__ + "img/p-08.da83e779.webp";